import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import Footer from "./../../../footer";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";

const ProcedureGroups = () => {
  // Mock data for Permission Groups
  const mockPermissionGroups = [
    {
      _id: "1",
      name: "Administrators",
    },
    {
      _id: "2",
      name: "Editors",
    },
    {
      _id: "3",
      name: "Viewers",
    }
  ];

  const [rows, setRows] = useState(mockPermissionGroups);
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    setRows(mockPermissionGroups);
  }, []);

  const handleEdit = (id) => {
    const rowData = rows.find((row) => row._id === id);
    setSelectedRowData(rowData);
    setIsEditModalOpen(true);
  };

  const handleDelete = (id) => {
    setRows(rows.filter((row) => row._id !== id));

  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedRowData(null);
  };

  const handleSaveChanges = () => {
    if (!selectedRowData) {
      console.error("Selected row data is missing");
      return;
    }
    
    const updatedRows = rows.map((row) =>
      row._id === selectedRowData._id ? { ...row, ...selectedRowData } : row
    );
    setRows(updatedRows);
    setIsEditModalOpen(false);
    setSelectedRowData(null);

  };

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const columns = [
  { field: "name", headerName: "Name", width: 1100 },
  {
    field: "actions",
    headerName: "Actions",
    width: 200,
    renderCell: (params) => {
      return (
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleEdit(params.row._id)}
            style={{ backgroundColor: "#004aad", fontSize: "14px" }}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "red",
              "&:hover": { backgroundColor: "#c62828" },
            }}
            onClick={() => handleDelete(params.row._id)}
          >
            Delete
          </Button>
        </div>
      );
    },
  },
];

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/users"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/accountTable"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/financeOwerview"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/casesetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: " #004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-10">
            <h2 className="title">Permission Groups</h2>
            <div
              className="search"
              style={{ border: "white", padding: "10px" }}
            >
              <div className="row align-items-center">
                <div className="col-md-9 d-flex justify-content-between">
                  <div className="col-md-3 d-flex justify-content-start">
                    <input
                      type="text"
                      id="searchInput"
                      className="form-control"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <Link
                    to="/AddPermissionGroup"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#004aad",
                      borderColor: "#004aad",
                    }}
                  >
                    + Add
                  </Link>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                backgroundColor: "#f5f5f5",
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <DataGrid
                rows={filteredRows}
                columns={columns}
                pageSize={filteredRows.length}
                getRowId={(row) => row._id}
                autoHeight
                hideFooter
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f0f0f0",
                    fontWeight: "bold",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #ddd",
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    overflow: "visible !important",
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>

      {/* Edit Modal - Simplified to only edit name */}
      <Dialog open={isEditModalOpen} onClose={handleModalClose}>
        <DialogTitle>Edit Permission Group</DialogTitle>
        <DialogContent>
          {selectedRowData && (
            <div>
              <TextField
                label="Name"
                value={selectedRowData.name}
                onChange={(e) =>
                  setSelectedRowData({
                    ...selectedRowData,
                    name: e.target.value,
                  })
                }
                fullWidth
                margin="normal"
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveChanges} color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProcedureGroups;